import React, { useState } from "react";

import recipe from "../assets/images/recipe.png";
import apple from "../assets/images/Apple.png";
import google from "../assets/images/google.png";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { firestoredDB } from "../config/firebase";
import { addDoc, collection, getDocs, where } from "firebase/firestore";
import swal from "sweetalert";
import { isValidEmail } from "../utils/checkEmail";
import { query } from "firebase/database";
import support_icon from "../assets/images/Support.svg";
import { playAudio } from "../utils/btnAudio";
// import CButton from "./CButton";
import bgImage from "../assets/landing/banner-bg.png";
import { CButton } from "./CommonComponents";

const CButtonLandingPage = ({ text, img }) => {
  return (
    <button className="flex items-center px-6 py-1 rounded-full border border-white bg-white font-semibold shadow-md transform transition-transform hover:scale-105">
      <span className="mr-2 text-xl" role="img" aria-label="Apple">
        <img src={img}></img>
      </span>
      <span
        className="bg-clip-text text-transparent font-extrabold font-raleway"
        style={{
          background: "linear-gradient(90deg, #DE519A 0%, #6A7EFC 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {text}
      </span>
    </button>
  );
};
export default function HeroHome() {
  const navigate = useNavigate();

  const { isLoggedIn, user } = useSelector((state) => state.auth);

  // const onSubmitEmail = async (e) => {
  //   e.preventDefault();

  //   if (!isValidEmail(email)) {
  //     swal({
  //       icon: "info",
  //       title: "Please enter a valid Email!",
  //       showConfirmButton: false,
  //       timer: 2000,
  //     });
  //     return;
  //   }
  //   try {
  //     // Check if the email already exists in the "Subscribers" collection
  //     const q = query(subscribersRef, where("email", "==", email));
  //     const querySnapshot = await getDocs(q);

  //     if (!querySnapshot.empty) {
  //       swal({
  //         icon: "info",
  //         title: "Email already subscribed!",
  //         showConfirmButton: false,
  //         timer: 2000,
  //       });
  //       return;
  //     }

  //     await addDoc(subscribersRef, {
  //       // userId: user?.user?.uid,
  //       email: email,
  //     });

  //     swal({
  //       icon: "success",
  //       title: "You have successfully subscribed to Cook-E",
  //       showConfirmButton: false,
  //       timer: 2000,
  //       confirmButtonColor: "#f0481a",
  //     });
  //   } catch (err) {
  //     console.log(err.message);

  //     swal({
  //       icon: "info",
  //       title: err.message,
  //       showConfirmButton: false,
  //       timer: 2000,
  //     });
  //   }
  // };

  return (
    <section
      className="relative h-full pb-10 pt-24 no-repeat bg-cover bg-center md:min-h-[750px]"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className=" mx-0 px-4 flex justify-center items-center ">
        <div className=" h-full w-full">
          <div className="mx-auto flex h-full flex-col justify-center items-center w-full relative">
            {/* Background image */}

            <div className=" flex lg:flex-row flex-col h-[60%] w-[100%] ">
              <motion.div
                // className="md:-mt-20"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.5 }}
                variants={{
                  hidden: { opacity: 0, x: -50 },
                  visible: { opacity: 1, x: 0 },
                }}
                className="md:flex-[90%] flex-col justify-center"
              >
                <div className="space-y-6 flex flex-col justify-between h-full md:px-12 px-2 max-w-[80%] lg:w-full">
                  <h1 className="md:text-8xl text-3xl text-white font-arbutus font-normal">
                    COOK-E AI
                  </h1>
                  <h1 className="md:text-3xl text-xl text-white font-publicSans font-semibold max-w-[100%] lg:max-w-full">
                    Your AI powered virtual cooking assistant from the future
                    has arrived{" "}
                  </h1>
                  <h1 className="md:text-3xl text-2xl text-white font-raleway font-extrabold pb-3">
                    Just ask COOK-E
                  </h1>

                  <div>
                    <CButton
                      onClick={() => {
                        if (isLoggedIn) {
                          navigate("/discover-dishes");
                        } else {
                          navigate("/signin");
                        }
                      }}
                      label={"Get Started"}
                      variant={"white"}
                    />
                  </div>
                </div>
              </motion.div>

              <motion.div
                // className="md:-mt-20"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.5 }}
                variants={{
                  hidden: { opacity: 0, x: +50 },
                  visible: { opacity: 1, x: 0 },
                }}
                className="md:flex-[40%] relative md:h-auto hidden 
                     lg:flex flex-col justify-between items-center order-2"
              >
                <img
                  src={recipe}
                  className=" 
                          rounded-full w-auto h-[70%] 2xl:p-16 min-h-[415px] 2xl:h-full
                         px-10 py-2 
                         "
                />
              </motion.div>
              <div
                // className="md:-mt-20"

                className="absolute lg:hidden sm:right-[2%] right-0 xs:top-[15%] sm:top-[20%] top-[35%]  items-end
                     flex flex-col justify-between"
              >
                <img
                  src={recipe}
                  className=" 
                          rounded-full sm:w-[70%] h-[50%] w-[50%]
                        
                         "
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 sm:mt-12 mt-24">
              {/* iOS Button */}
              <CButtonLandingPage text={"Download for iOS"} img={apple} />
              <CButtonLandingPage text={"Download for Android"} img={google} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
